











import { defineComponent } from '@vue/composition-api';
import { useFormat } from 'vivat';
import useDelivery from '@/useDelivery';

const CommonTimeline = defineComponent({
  props: {
    log: {},
    index: {},
    length: {},
  },
  setup() {
    const { translate } = useDelivery();
    function dateFormat(date: string) {
      return useFormat.date(date).displayShortThaiDateTime();
    }
    return {
      dateFormat,
      translate,
    };
  },
});

export default CommonTimeline;
